exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.md-app[data-v-e8da6b2c] {\n  min-height: 350px;\n  border: 1px solid rgba(0, 0, 0, 0.12);\n}\n.md-drawer[data-v-e8da6b2c] {\n  width: 230px;\n  max-width: calc(100vw - 125px);\n}\n", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/components/layouts/navigation.vue"],"names":[],"mappings":";AAAA;EACE,kBAAkB;EAClB,sCAAsC;CAAE;AAE1C;EACE,aAAa;EACb,+BAA+B;CAAE","file":"navigation.vue","sourcesContent":[".md-app {\n  min-height: 350px;\n  border: 1px solid rgba(0, 0, 0, 0.12); }\n\n.md-drawer {\n  width: 230px;\n  max-width: calc(100vw - 125px); }\n"],"sourceRoot":""}]);

// exports
